/**
 *
 * LoadingSpinner
 *
 */
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

const LoadingSpinner = ({
  position,
  spinColor,
  width,
  height,
  size = 40,
  thickness,
  style,
}) => (
  <Grid
    container
    style={{
      display: 'flex',
      position,
      top: 0,
      width: width || '100%',
      height,
      justifyContent: 'center',
      alignItems: 'center',
      ...style,
    }}
    justify="space-between"
    alignItems="stretch"
  >
    <CircularProgress
      size={size}
      thickness={thickness}
      sx={{
        color: spinColor,
        margin: 'auto',
        height: '100%',
      }}
    />
  </Grid>
);
LoadingSpinner.propTypes = {
  position: PropTypes.string,
  spinColor: PropTypes.string,
  size: PropTypes.number,
  width: PropTypes.string,
  height: PropTypes.string,
  thickness: PropTypes.number,
  style: PropTypes.object,
};

export default memo(LoadingSpinner);
